'use strict';
import { Pipe, PipeTransform } from '@angular/core';
import { Transaction } from '../../services/captable/transaction';

function kindDisplay(tran: Transaction) {
    if (tran) {
        if (tran.kind === "grant" && tran.attrs.amount) {
            return "purchase";
        } else if (tran.kind === "split") {
            return tran.attrs.from_ratio + ':' + tran.attrs.to_ratio + ' split';
        } else if (tran.kind === 'dividend') {
            return tran.attrs.paymenttype + ' ' + tran.kind;
        } else {
            return tran.kind;
        }
    } else {
        return '';
    }
}

@Pipe({name: 'kindDisplay'})
export class KindDisplayPipe implements PipeTransform {
    transform(tran: Transaction): string {
        return kindDisplay(tran);
    }
}



// WEBPACK FOOTER //
// ./_src/ui/elements/kindDisplayPipe.ts